import { ContextService } from '../../../services/context_service';
import { DataService } from '../../../services/data_service';
import { disableKosten } from '../../../helpers/showKosten';
import { fn0nZ } from '../../../core/formatter/formatNumber';
import { getCustomFormConfig } from '../co2_custom/getCustomFormConfig';
import { getHochrechnung } from './getHochrechnung';
import { IDs } from '../../../helpers/IDs';
import { isValid } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { renderGTZHochrechnung } from './renderGTZHochrechnung';
import { renderVerbrauchRechnungen } from './renderVerbrauchRechnungen';
import style from './hochrechnung.less';
import { toFixedDecimal } from '../../../core/formatter/formatNumber';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../functions/validateField';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';

interface DialogOelBerechnungProps extends React.ClassAttributes<any> {
    data: any;
    standortSelected: any;
    jahr: number;
    energietraeger: number;
    einheit: number;
    values: any;
    onClose: () => void;
    onTake: (verbrauch: number, kosten: number) => void;
}

interface DialogOelBerechnungState {
    tabIndex: number;
    hochrechnungGtz: any;
    preis: number;
    rechnungen: any[];
    showPrognoseOnly: boolean;
    validRestriction: string;
}

export class DialogOelBerechnung extends React.Component<DialogOelBerechnungProps, DialogOelBerechnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            hochrechnungGtz: undefined,
            preis: 1,
            rechnungen: [],
            showPrognoseOnly: false,
            tabIndex: this.contextService.get('tabIdxDialogOelBerechnung') ? this.contextService.get('tabIdxDialogOelBerechnung') : 0,
            validRestriction: null
        };
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private disableKosten: boolean;
    private formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
    private formatEuro: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true });

    componentDidMount(): void {
        const unt_daten = this.props.data[IDs.ENT_UNTERNEHMENSDATEN];
        let ort_tid = 196; // Irgendein Ort
        this.disableKosten = disableKosten(this.props.data);

        if (unt_daten && unt_daten.length > 0) {
            const ort_gtz = unt_daten[0].ort_gtz;
            const ent_orte = this.props.data[IDs.ENT_GTZ_ORTE];
            const ort_found = ent_orte.find((o: any) => o.ort === ort_gtz);

            if (ort_found) {
                ort_tid = ort_found.tid;
            }
        }
        this.dataService.loadDataForModul(
            IDs.ENT_GTZ, { ort_tid }, {}, IDs.MOD_ETOOL_ADMIN,
            (res: any) => this.setState({ hochrechnungGtz: res[IDs.ENT_GTZ] })
        );
    }

    render(): JSX.Element {
        if (!this.state.hochrechnungGtz) {
            return <div>Lade Daten ...</div>;
        }
        const hochrechnung = getHochrechnung(
            this.state.hochrechnungGtz, this.props.standortSelected, this.props.energietraeger, this.props.einheit,
            this.props.data, this.props.values, this.props.jahr
        );
        const preis: number = (hochrechnung || {}).preis || 1;
        const rechnungen: any[] = (hochrechnung || {}).verbrauch_rechnungen || [];
        if (preis !== this.state.preis || rechnungen.length !== this.state.rechnungen.length) {
            this.setState({ preis, rechnungen });
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: 35 }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ margin: 10 }}>
                        <div style={{ marginBottom: 10, fontWeight: 'bold' }}>Berechnung Prognose</div>
                        {this.renderBerechnung(hochrechnung)}
                        {/*this.renderUebernahme(hochrechnung)*/}
                    </div>
                    <div style={{ margin: 10, fontWeight: 'bold' }}>
                        <div style={{ marginBottom: 10 }}>Erfassung Brennstoff-Abrechnungen</div>
                        {this.renderTableAbrechnung()}
                    </div>
                    <div style={{ position: 'absolute', right: -40, top: 10 }}>
                        {this.renderHilfeSymbol()}
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%', padding: '0 10px'
                    }}
                >
                    {this.state.tabIndex === 0 && this.renderButtonSave()}
                    {/* {this.renderButtonClose()} */}
                </div>
            </div>
        );
    }

    renderHilfeSymbol(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                // styleDivProps={{ display: 'inline-block', marginLeft: -100 }}
                styleDivProps={{ marginTop: 2, marginLeft: -88 }}
                // styleProps={{
                //     width: 18, height: 20, borderRadius: 10, backgroundColor: 'transparent', verticalAlign: 'top', margin: 0
                // }}
                styleProps={{ margin: 0 }}
                label='Rechner - Brennstoffe'
                helpKey='dialog_rechner_oel'
                style={'theme_small'}
                type={'theme_info'}
                customElement={'Info'}
                editBar
                useTheme
            />
        );
    }

    renderBerechnung(hochrechnung: any): JSX.Element {
        const einheit = this.getEinheitName();
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {/*renderGTZHochrechnung(this.state.hochrechnung, this.props.jahr) */}
                {renderVerbrauchRechnungen(
                    hochrechnung, this.props.jahr, this.state.preis, einheit, this.disableKosten, (preis: number) => this.setState({ preis }))
                }
            </div>
        );
    }

    renderButtonClose(): JSX.Element {
        return (
            <WActionButton
                label='Schließen'
                insideText='Schließen'
                key='close'
                action='delete'
                onAction={this.props.onClose}
            />
        );
    }

    renderButtonSave(): JSX.Element {
        return (
            <WActionButton
                label='Werte übernehmen'
                insideText='Werte übernehmen'
                key='save'
                action='save'
                onAction={() => {
                    const hochrechnung = getHochrechnung(
                        this.state.hochrechnungGtz, this.props.standortSelected, this.props.energietraeger, this.props.einheit,
                        this.props.data, this.props.values, this.props.jahr
                    );
                    const verbrauch = hochrechnung.verbrauch_prognose;
                    const kosten = Math.round(verbrauch * this.state.preis);
                    // console.log(verbrauch, toFixedDecimal(verbrauch), kosten, toFixedDecimal(kosten));
                    if (isNaN(verbrauch)) {
                        alert('Keine Verbrauchsprognose für das ausgewählte Jahr vorhanden!');
                    } else {
                        this.props.onTake(toFixedDecimal(verbrauch), toFixedDecimal(kosten));
                    }
                }}
            />
        );
    }

    renderHeaderElements(): JSX.Element[] {
        const style: React.CSSProperties = {
            cursor: 'pointer', display: 'flex', alignItems: 'center', height: 28, marginTop: 2, fontSize: 12, padding: '0 3px',
            backgroundColor: 'rgb(188, 202, 227)', marginRight: 2
        };

        return [
            <label style={style} key='prognose'>
                <input
                    type='checkbox'
                    checked={this.state.showPrognoseOnly}
                    onChange={(event: any) => this.setState({ showPrognoseOnly: event.target.checked })}
                />
                Nur die für {this.props.jahr || ''} relevanten Werte anzeigen
            </label>
        ];
    }

    renderTableAbrechnung(): JSX.Element {
        const einheit = this.getEinheitName();
        const rechnungen: any[] = (this.state.rechnungen || []).map((rechnung: any) => rechnung.datum_bis);
        return (
            <WFormsTableWrapper
                module={IDs.MOD_ETOOL}
                entity={IDs.ENT_OEL_ABRECHNUNG}
                preFilterFunction={(data: any[]) => data.filter((item: any) =>
                    this.state.showPrognoseOnly ? rechnungen.indexOf(item.datum_befuellung) !== -1 : true
                )}
                preFilter={{
                    standort_tid: this.props.standortSelected.tid, einheit_tid: this.props.einheit,
                    energietraeger_tid: this.props.energietraeger
                }}
                formPreset={{
                    standort_tid: this.props.standortSelected.tid, einheit_tid: this.props.einheit,
                    energietraeger_tid: this.props.energietraeger
                }}
                actions={['add', 'edit', 'delete']}
                externalHeaderElements={this.renderHeaderElements()}
                customClass='Custom-ETA'
                formLayout='flowV2'
                formLayout2='noneAutoSave'
                addLabel='Abrechnung erfassen'
                customFormatter={(field: string, value: any, data: any, row: any) => {
                    if (['kosten', 'fuellmenge'].indexOf(field) !== -1 && typeof value === 'number') {
                        value = field == 'kosten' ? this.formatEuro.format(value) : this.formatFloat.format(value);
                        if (rechnungen.indexOf((data || {}).datum_befuellung) !== -1) {
                            return <span style={{ color: 'blue' }}>{value}</span>;
                        }
                    }
                    return value;
                }}
                customFormConfig={{
                    ...(getCustomFormConfig(IDs.ENT_OEL_ABRECHNUNG, null, this.props.data) || {}),
                    standort_tid: { hidden: true }, einheit_tid: { hidden: true }, energietraeger_tid: { hidden: true },
                    fuellmenge: { label: `Füllmenge [${einheit}]`, header: `Füllmenge [${einheit}]` }
                }}
                hiddenColumns={['standort_tid', this.disableKosten && 'kosten']}
                validateField={this.validateField}
                validRestriction={this.state.validRestriction}
                callBeforeOnFormSave={(data: any, callback: () => void) =>
                    this.setState(
                        { validRestriction: !isValid(data || {}, IDs.ENT_OEL_ABRECHNUNG, this.props.data, true) ? 'stop' : null },
                        () => callback()
                    )
                }
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_OEL_ABRECHNUNG)}
                onDelDone={() => this.triggerService.fire('reload', IDs.ENT_OEL_ABRECHNUNG)}
                tablePageSize={10}
            />
        );
    }

    getEinheitName() {
        const { data, einheit } = this.props;
        const einheitFnd = data[IDs.ENT_ENERGIEDATEN_WAERME_EINHEITEN].find((r: any) => r.tid === +einheit);
        if (einheitFnd) {
            return einheitFnd.name;
        }
    }

    renderTableZaehlerablesung(): JSX.Element {
        return (
            <WFormsTableWrapper
                module={IDs.MOD_ETOOL}
                entity={IDs.ENT_OEL_ZAEHLERABLESUNG}
                preFilter={{ standort_tid: this.props.standortSelected.tid }}
                formPreset={{ standort_tid: this.props.standortSelected.tid, art: 1 }}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                formLayout2='noneAutoSave'
                addLabel='Zählerablesung erfassen'
                customFormConfig={{ standort_tid: { readonly: true } }}
                disableFieldSelectDefaultOptions={{ art: true }}
                hiddenColumns={['standort_tid']}
            />
        );
    }

    renderUebernahme(hochrechnung: any): JSX.Element {
        const einheit: string = this.getEinheitName();
        const verbrauch: number = hochrechnung.verbrauch_prognose;
        const kosten: number = Math.round(verbrauch * this.state.preis);

        if (isNaN(verbrauch)) {
            return null;
        }
        return (
            <div className={style.res_titel}>
                <br /><br />
                Werte für die Übernahme
                <br />
                <br />
                <span className={style.res_label}>Verbrauch</span>
                <span className={style.res_value}>{fn0nZ(verbrauch)} {einheit}</span>
                <br />
                <span className={style.res_label}>Kosten</span>
                <span className={style.res_value}>{fn0nZ(kosten)} €</span>
            </div>
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_OEL_ABRECHNUNG, key, value, data, onValueChange, this.props.data);
    }
}
